import { render, staticRenderFns } from "./abnormal-history.vue?vue&type=template&id=440dc4c0&scoped=true&"
import script from "./abnormal-history.vue?vue&type=script&lang=js&"
export * from "./abnormal-history.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-history.vue?vue&type=style&index=0&id=440dc4c0&scoped=true&lang=css&"
import style1 from "./abnormal-history.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440dc4c0",
  null
  
)

export default component.exports